"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _checkTypes = _interopRequireDefault(require("check-types"));

var _countriesData = require("../00_environment/countriesData");

var _FormElementGroup = _interopRequireDefault(require("../01_atoms/FormElementGroup"));

var _FormElement = _interopRequireDefault(require("../01_atoms/FormElement"));

var _PhoneInput = _interopRequireDefault(require("../01_atoms/PhoneInput"));

var _AddressFormComponent = _interopRequireDefault(require("./AddressFormComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EditPassengerFormUI = function EditPassengerFormUI() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$hasErrors = _ref.hasErrors,
      hasErrors = _ref$hasErrors === void 0 ? function () {
    return (
      /* ...fields */
      false
    );
  } : _ref$hasErrors,
      translatorForNamespace = _ref.translatorForNamespace,
      _ref$config = _ref.config,
      rawConfig = _ref$config === void 0 ? {} : _ref$config;

  // console.log('Rendering EditPassengerFormUI');
  var _value$firstName = value.firstName,
      firstName = _value$firstName === void 0 ? '' : _value$firstName,
      _value$lastName = value.lastName,
      lastName = _value$lastName === void 0 ? '' : _value$lastName,
      _value$ssn = value.ssn,
      ssn = _value$ssn === void 0 ? '' : _value$ssn,
      _value$country = value.country,
      country = _value$country === void 0 ? 'EC' : _value$country,
      _value$phone = value.phone,
      phone = _value$phone === void 0 ? '' : _value$phone,
      _value$email = value.email,
      email = _value$email === void 0 ? '' : _value$email,
      _value$address = value.address,
      address = _value$address === void 0 ? {} : _value$address;
  var t = translatorForNamespace('EditPassengerForm'); // Generate config from rawConfig

  var defaultItemConfig = function defaultItemConfig() {
    return {
      title: null,
      subtitle: null,
      show: true
    };
  };

  var config = {
    name: defaultItemConfig(),
    email: _objectSpread(_objectSpread({}, defaultItemConfig()), {}, {
      show: false
    }),
    phone: defaultItemConfig(),
    ssn: defaultItemConfig(),
    address: _objectSpread(_objectSpread({}, defaultItemConfig()), {}, {
      show: false
    })
  };

  if (_checkTypes["default"].nonEmptyObject(rawConfig)) {
    Object.keys(config).forEach(function (key) {
      config[key] = _objectSpread(_objectSpread({}, config[key]), rawConfig[key] || {});
    });
  }

  var applyChange = function applyChange() {
    var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return onChange(_objectSpread(_objectSpread({}, value), change));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, config.name.show && /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
    title: config.name.title || t('Passenger name'),
    subtitle: config.name.subtitle || t('Will display on your tickets')
  }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, {
    widths: "equal"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('First name'),
    value: firstName || '',
    onChange: function onChange(e, o) {
      return applyChange({
        firstName: o.value
      });
    },
    style: {
      marginTop: 10,
      marginBottom: 10
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('Last name'),
    value: lastName || '',
    onChange: function onChange(e, o) {
      return applyChange({
        lastName: o.value
      });
    },
    style: {
      marginTop: 10,
      marginBottom: 10
    }
  })))), config.email.show && /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
    title: config.email.title || t('E-mail'),
    subtitle: config.email.subtitle || null,
    noPadding: true
  }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, {
    widths: "equal"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('E-mail'),
    value: email || '',
    onChange: function onChange(e, o) {
      return applyChange({
        email: o.value
      });
    },
    style: {
      marginTop: 10,
      marginBottom: 10
    }
  })))), config.phone.show && /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
    title: config.phone.title || t('Phone number'),
    subtitle: config.phone.subtitle || t('Used to send ticket information')
  }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, {
    widths: "equal"
  }, /*#__PURE__*/_react["default"].createElement(_PhoneInput["default"], {
    placeholder: t('Mobile phone'),
    defaultCountry: "ec",
    value: phone,
    onChange: function onChange(v, _ref2) {
      var countryCode = _ref2.countryCode;

      if (!_checkTypes["default"].nonEmptyString(country)) {
        applyChange({
          phone: v,
          country: countryCode
        });
      } else {
        applyChange({
          phone: v
        });
      }
    },
    inputStyle: {
      width: '100%',
      height: 38,
      marginTop: 10,
      marginBottom: 10,
      borderColor: '#22242626',
      borderRadius: '5px'
    }
  })))), config.ssn.show && /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
    title: config.ssn.title || t('Identification document'),
    subtitle: config.ssn.subtitle || t('Necessary to onboard the bus')
  }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Dropdown, {
    placeholder: t('Country'),
    fluid: true,
    search: true,
    selection: true,
    options: _countriesData.COUNTRY_OPTIONS,
    value: country || 'ec',
    onChange: function onChange(e, o) {
      return applyChange({
        country: o.value
      });
    },
    style: {
      marginTop: 10,
      marginBottom: 10
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
    error: _checkTypes["default"].nonEmptyString(ssn) && hasErrors('ssn', 'cedula'),
    fluid: true,
    placeholder: !country || country === 'ec' ? t('Cedula') : t('Passport number'),
    value: ssn || '',
    onChange: function onChange(e, o) {
      return applyChange({
        ssn: o.value
      });
    },
    style: {
      marginTop: 10,
      marginBottom: 10
    }
  }))), config.address.show && /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
    title: config.address.title || t('Address'),
    subtitle: config.address.subtitle || null
  }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_AddressFormComponent["default"], {
    title: null,
    style: {},
    address: address,
    onChange: function onChange(v) {
      return applyChange({
        address: v
      });
    },
    translatorForNamespace: translatorForNamespace
  }))));
};

var _default = EditPassengerFormUI;
exports["default"] = _default;